/*
 * Custom: Hero Slider
 * Wraps the Custom: Hero appearance in an accessible-slick fade slideshow.
 * Each slide re-runs the hero entrance animations (background zoom + staggered
 * text reveal) as it becomes active, driven by the `.slick-active` class in CSS.
 * Loaded after custom-jquery.min.js and custom-accessible-slick.min.js (deferred, in order).
 */
(function () {
  var STAGGER = 120; // ms between each revealed element
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Assign per-element animation delays so each slide's content reveals in
  // document order (eyebrow → heading → content → cta).
  function setStagger(root) {
    var slides = root.querySelectorAll('.custom-hero-slider__slide');
    for (var s = 0; s < slides.length; s++) {
      var reveals = slides[s].querySelectorAll('.custom-hero-slider__reveal');
      for (var i = 0; i < reveals.length; i++) {
        reveals[i].style.animationDelay = i * STAGGER + 'ms';
      }
    }
  }

  function initSlider(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      return;
    }

    var $slides = $(root).find('.custom-hero-slider__slides');
    if (!$slides.length || $slides.hasClass('slick-initialized')) {
      return;
    }

    setStagger(root);

    var data = root.dataset;
    $slides.slick({
      dots: true,
      arrows: false,
      autoplay: data.autoplay === 'true',
      autoplaySpeed: parseInt(data.autoplaySpeed, 10) || 5000,
      speed: parseInt(data.speed, 10) || 1000,
      fade: true,
      pauseOnHover: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      // accessible-slick options
      regionLabel: 'Hero',
      useGroupRole: true,
			playIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"> aria-hidden="true"<!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>',
			pauseIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" aria-hidden="true"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 64h64v384H64zm128 0h64v384h-64z"/></svg>',

    });
  }

  function destroySlider(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      return;
    }
    var $slides = $(root).find('.custom-hero-slider__slides');
    if ($slides.hasClass('slick-initialized')) {
      $slides.slick('unslick');
    }
  }

  // Parallax: shift the background images on scroll, mirroring Custom: Hero.
  // All slides share one offset since only the active slide is visible.
  function initParallax(root) {
    if (reducedMotion) {
      return;
    }
    var images = root.querySelectorAll('.custom-hero-slider__image');
    if (!images.length) {
      return;
    }

    // The images are 120% tall, so they have 10% of slack above and below.
    var STRENGTH = 0.12;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        return;
      }
      var progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      var slack = rect.height * 0.1;
      var offset = -progress * rect.height * STRENGTH;
      offset = Math.max(-slack, Math.min(slack, offset));
      var transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
      for (var i = 0; i < images.length; i++) {
        images[i].style.transform = transform;
      }
    }

    function onScroll() {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init(root) {
    initSlider(root);
    initParallax(root);
  }

  function initAll() {
    var sections = document.querySelectorAll('.custom-hero-slider');
    for (var i = 0; i < sections.length; i++) {
      init(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.custom-hero-slider');
    if (el) {
      init(el);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('.custom-hero-slider');
    if (el) {
      destroySlider(el);
    }
  });

  // Advance to the slide being edited in the theme editor.
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.custom-hero-slider');
    if (!root) {
      return;
    }
    var $ = window.jQuery;
    var $slides = $ && $(root).find('.custom-hero-slider__slides');
    if ($slides && $slides.hasClass('slick-initialized')) {
      var index = parseInt(event.target.getAttribute('data-slide-index'), 10);
      if (!isNaN(index)) {
        $slides.slick('slickGoTo', index);
      }
    }
  });
})();
